import styles from './styles.module.scss';
import { Button } from 'packages/radiant-react/button';
import { IconColor, IconID } from 'packages/radiant-react/icon';
import { CARD_DETAILS } from 'components/AiMode/constants';
import { Horizontal, Vertical } from 'packages/radiant-react/layout';
import { Colors, Typography } from 'packages/radiant-react/typography';

function PendoCard({ handleClose }: { handleClose: () => void }) {
  return (
    <Vertical className={styles['main-container']}>
      <Vertical className={styles['content-container']}>
        <Typography variant="h3" className={styles['top-shape']}>
          {''}
        </Typography>
        <Horizontal className={styles['content-header']} vAlignContent="center">
          <Typography variant="h4" color={Colors.white}>
            {CARD_DETAILS.title}
          </Typography>
          <Button
            icon={IconID.CROSS}
            type="tertiary"
            onClick={handleClose}
            iconColor={IconColor.WHITE}
            backgroundType={'light'}
          />
        </Horizontal>
        <Typography variant="p" color={Colors.white}>
          {CARD_DETAILS.content}
        </Typography>
      </Vertical>
    </Vertical>
  );
}

export default PendoCard;
